import styled from '@emotion/styled';
import type { CSSProperties } from 'react';

export const Devider = styled.div<{ bottomSpace?: CSSProperties['marginBottom'] }>`
  border-bottom: solid 1px lightgray;
  margin-bottom: ${({ bottomSpace = '10px' }) => bottomSpace};
  width: 100%;
`;
